import type { TPenilaiPerencanaanMenu } from 'types/kinerja-tim-penilai-ps'

export const PERENCANAAN_STEPS_TIM_KINERJA = [
  {
    title: 'Cek Perencanaan',
    subtitle: 'Oleh Anda dan Pejabat Penilai Kinerja',
    icon: 'img-clip-board-summary',
  },
  {
    title: 'Kirim ke Kepala Pejabat Penilai Kinerja',
    subtitle: 'Oleh Anda',
    icon: 'img-publish-data',
  },
  {
    title: 'Persetujuan Perencanaan',
    subtitle: 'Oleh Pejabat Penilai Kinerja',
    icon: 'img-document-penci-fill',
  },
  {
    title: 'Tahap Pelaksanaan',
    subtitle: 'Oleh Pengawas Sekolah',
    icon: 'img-thumbs-up',
  },
]

export const PERENCANAAN_STEPS_PEJABAT_PENILAI_KINERJA = [
  {
    title: 'Cek Perencanaan',
    subtitle: 'Oleh Anda dan Tim Kinerja',
    icon: 'img-clip-board-summary',
  },
  {
    title: 'Setujui Perencanaan',
    subtitle: 'Oleh Anda',
    icon: 'img-document-penci-fill',
  },
  {
    title: 'Tahap Pelaksanaan',
    subtitle: 'Oleh Pengawas Sekolah',
    icon: 'img-thumbs-up',
  },
]

export const PERENCANAAN_TIM_KINERJA_MENUS: TPenilaiPerencanaanMenu[] = [
  {
    title: 'Sudah diajukan Pengawas',
    subtitle: 'Cek dan kirim ke Pejabat Penilai Kinerja.',
    textColor: 'inverse',
    ctaText: 'Cek Perencanaan',
    ctaColor: 'blue',
    bgColor: '!bg-expressive-dark-blue',
    path: '/penilai/perencanaan/daftar-ps',
  },
  {
    title: 'Belum diajukan Pengawas',
    subtitle: 'Kabari Pengawas untuk segera mengajukan.',
    ctaText: 'Cek daftar Pengawas',
    textColor: 'default',
    ctaColor: 'white',
    path: '/penilai/perencanaan/daftar-ps/belum-diajukan',
  },
]

export const PERENCANAAN_PEJABAT_PENILAI_KINERJA_MENUS: TPenilaiPerencanaanMenu[] =
  [
    {
      title: 'Setujui sekaligus',
      subtitle: 'Setujui perencanaan yang sudah diperiksa Tim Kinerja.',
      textColor: 'inverse',
      ctaText: 'Cek Perencanaan',
      ctaColor: 'blue',
      bgColor: '!bg-expressive-dark-blue',
      path: '/penilai/perencanaan/daftar-ps/setujui-sekaligus',
    },
    {
      title: 'Setujui satu per satu',
      subtitle:
        'Cek tiap perencanaan Pengawas untuk setujui atau arahkan revisi.',
      textColor: 'default',
      ctaText: 'Cek Perencanaan',
      ctaColor: 'white',
      path: '/penilai/perencanaan/daftar-ps',
    },
    {
      title: 'Belum diajukan Pengawas',
      subtitle: 'Kabari Pengawas untuk segera mengajukan.',
      textColor: 'default',
      ctaText: 'Cek daftar Pengawas',
      ctaColor: 'white',
      path: '/penilai/perencanaan/daftar-ps/belum-diajukan',
    },
  ]

export const PERENCANAAN_PENGEMBANGAN_KOMPETENSI_HINTS: Array<string> = [
  'Berdasarkan diskusi dengan Pengawas tentang fokus dan kemampuan selama 6 bulan ke depan',
  'Berdasarkan hasil Refleksi Kompetensi Pengawas',
]
